import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const customerApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

customerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

customerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('customer_token');
      window.location.href = '/customer/login';
    }
    return Promise.reject(error);
  }
);

export const getCatalog = () => customerApi.get('/customer/catalog');
export const getAvailableDates = () => customerApi.get('/customer/available-dates');
export const getCustomerOrders = () => customerApi.get('/customer/orders');
export const getCustomerOrder = (id) => customerApi.get(`/customer/orders/${id}`);
export const createCustomerOrder = (data) => customerApi.post('/customer/orders', data);
export const getAvailableCoupons = () => customerApi.get('/customer/coupons');

// Sale Visibility (認証不要 - 公開APIを使用)
export const getSaleVisibility = () => customerApi.get('/settings/sale-visibility');
export const getCustomerAnnouncements = () => customerApi.get('/announcements');

export default customerApi;
